import { render, staticRenderFns } from "./FacetChipGroup.vue?vue&type=template&id=918f1f32&scoped=true&"
import script from "./FacetChipGroup.vue?vue&type=script&lang=ts&"
export * from "./FacetChipGroup.vue?vue&type=script&lang=ts&"
import style0 from "./FacetChipGroup.vue?vue&type=style&index=0&id=918f1f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918f1f32",
  null
  
)

export default component.exports